import makeApiRequest from "./clients/apiRequest";
import { gateway } from "./clients/baseClient";
import { versionApiPath } from "./common";
import { ENDPOINTS } from "./endpoints";
import { AlertsPageBody } from "./types/alerts";
import { ResponseData } from "./types/api";

export async function alertsPage(body: AlertsPageBody): Promise<ResponseData> {
  const data = {
    endpoint: `${versionApiPath}/${ENDPOINTS.ALERTS.PAGE}`,
    body: body,
  };
  return await makeApiRequest(
    {
      url: ``,
      method: "post",
      data: data,
    },
    gateway,
    false
  );
}

export async function alertsGet(alertId: string): Promise<ResponseData> {
  const data = {
    endpoint: `${versionApiPath}/${ENDPOINTS.ALERTS.GET}`,
    body: {
      alertId: alertId,
    },
  };
  return await makeApiRequest(
    {
      url: ``,
      method: "post",
      data: data,
    },
    gateway,
    false
  );
}

export async function alertEscalate(
  alertId: string,
  comment: string
): Promise<ResponseData> {
  const data = {
    endpoint: `${versionApiPath}/${ENDPOINTS.ALERTS.ESCALATE}`,
    body: {
      alertId: alertId,
      comment: comment,
    },
  };
  return await makeApiRequest(
    {
      url: ``,
      method: "post",
      data: data,
    },
    gateway,
    false
  );
}

export async function alertUpdateStatus(
  alertId: string,
  comment: string,
  state: "CLOSED" | "ACKNOWLEDGED" | "COMMENT"
): Promise<ResponseData> {
  const data = {
    endpoint: `${versionApiPath}/${ENDPOINTS.ALERTS.UPDATE_STATE}`,
    body: {
      alertId: alertId,
      comment: comment,
      state: state,
    },
  };
  return await makeApiRequest(
    {
      url: ``,
      method: "post",
      data: data,
    },
    gateway,
    false
  );
}
